import React from "react";
import { Link } from "react-router-dom";

const ShippingDelivery = () => {
  return (
    <>
      <div>
        <section className="bg-gray-100/50 py-20 lg:py-28 max-md:pt-[120px]">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

            {/* Section Header */}
            <div className="text-center">

              {/* Badge */}
              <div className="inline-flex items-center gap-2 rounded-full border border-[#1AAD9D50] bg-[#F4FFFE] px-4 py-2" data-aos="fade-down">
                <span className="relative flex h-2 w-2">

                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#1AAD9D] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#1AAD9D]" />
                </span>
                <span className="text-sm font-medium text-[#1AAD9D]">
                  Delivery Terms
                </span>
              </div>
              <h2 className="mt-4 font-display text-3xl font-bold text-gray-900 lg:text-4xl"  data-aos="fade-up" data-aos-delay={100}>
                Shipping & Delivery Policy
              </h2>
            </div>

            <div className="theme-container mx-auto mt-[40px]" data-aos="fade-up" data-aos-delay={200}>
              <div className="w-full">
                <div className="container">
                  <div className="services-details-items">
                    <div className="row">
                      <div className="col-xl-12 services-single-content">
                        <ul>
                          <li>
                            1. Service orders are fulfilled by our empanelled healthcare providers through their qualified technicians, phlebotomists, or staff.
                          </li>
                          <li>
                            2. Product orders are shipped through registered domestic courier companies and/or Speed Post only.
                          </li>
                          <li>
                            3. Orders are shipped within 0–7 days, or as per the delivery date agreed upon at the time of order confirmation, subject to courier company or postal service norms.
                          </li>
                          <li>
                            4. We are not liable for any delay in delivery by the courier company or postal authorities. We only guarantee to hand over the consignment to the courier company or postal authorities within 0–7 days from the date of order and payment, or as per the delivery date agreed upon at the time of order confirmation.
                          </li>
                          <li>
                            5. Delivery of all orders will be made to the address provided by the buyer.
                          </li>
                          <li>
                            6. Delivery of our services will be confirmed via your registered email ID. For any issues in utilizing our services, you may contact our helpdesk at <br /> &nbsp;
                            <a href="tel:918010961096" className="inline font-medium underline">
                              +91 80 1096 1096
                            </a>
                            &nbsp;or&nbsp;
                            <a href="mailto:info@opdcover.com" className="inline font-medium underline">
                              info@opdcover.com
                            </a>
                            .
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>


    </>
  );
};

export default ShippingDelivery;
